import { uniqBy } from 'lodash';
import { Component } from 'react';
import { Col, FormLabel, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { actions, Control, Errors, Form } from 'forms/rrf';
import { createPostcodePlan, getPostcodePlan, getPostcodePlanMeta, updatePostcodePlan } from '../../../../../actions/postcode-plan';
import BackLink from '../../../../../components/common/back-link/index';
import ArrowButton from '../../../../../components/common/button-arrow';
import FileUpload from '../../../../../components/common/form/elements/file-upload';
import RequiredDatePicker from '../../../../../components/common/form/elements/required-datepicker';
import RequiredInput from '../../../../../components/common/form/elements/required-input';
import RequiredMultiSelect from '../../../../../components/common/form/elements/required-multi-select';
import RequiredSelect from '../../../../common/form/elements/required-select';
import PageTitle from '../../../../../components/common/page-title';
import EligibilityDropdowns from '../../eligibility-dropdowns';

import './styles.css';

class AddPostcodePlans extends Component {
  componentDidMount() {
    const { dispatch } = this.props;

    this.id = +this.props.match.params.id;
    this.isClone = this.props.match.url.includes('clone');
    this.edit = !Number.isNaN(this.id) && !this.isClone;

    dispatch(getPostcodePlanMeta());

    if (this.edit || this.isClone) {
      dispatch(getPostcodePlan(this.id));
    } else {
      dispatch(actions.reset('deep.postcode_plan'));
    }
  }

  componentWillUnmount() {
    this.props.dispatch(actions.reset('deep.postcode_plan'));
  }

  componentDidUpdate(prevProps) {
    const { dispatch, formData } = this.props;

    if (formData.objective_type !== prevProps.formData.objective_type) {
      dispatch(actions.setValidity('deep.postcode_plan.end_date', { required: formData.objective_type !== 'Auto-EPOS' }));
      dispatch(actions.resetValidity('deep.postcode_plan.end_date'));
    }
  }

  onSubmit = (data) => {
    const { dispatch } = this.props;
    const isError = this.validateForm();

    if (isError) {
      return;
    }

    if (!this.edit) {
      dispatch(actions.submitFields('deep.postcode_plan', createPostcodePlan(data, dispatch)));
    } else {
      dispatch(actions.submitFields('deep.postcode_plan', updatePostcodePlan(this.id, data, dispatch)));
    }
  };

  validateForm = () => {
    const {
      dispatch,
      formData: {
        start_date: startDate,
        end_date: endDate,
        display_from_date: displayFromDate,
        display_to_date: displayToDate,
      }
    } = this.props;
    let isError = false;

    if (endDate !== '' && endDate < startDate) {
      dispatch(actions.setErrors('deep.postcode_plan.end_date', 'End date must be after the start date'));
      isError = true;
    }

    if (displayToDate !== '' && displayToDate < displayFromDate) {
      dispatch(actions.setErrors('deep.postcode_plan.display_to_date', 'Display to date must be after the display from date'));
      isError = true;
    }

    return isError;
  }
  pageTitle = () => {
    if (this.edit) {
      return 'EDIT';
    }

    if (this.isClone) {
      return 'CLONE';
    }

    return 'ADD';
  }

  render() {
    const {
      formValid,
      formData: {
        abm_codes: savedAbmCodes,
        products: savedProducts,
        start_date: startDate,
        end_date: endDate,
        display_from_date: displayFromDate,
        display_to_date: displayToDate,
        description,
        objective_type: objectiveType,
        mc_outlets: mcOutlets
      },
      postcodePlans: {
        fetched,
        meta: {
          products,
          objective_types: objectiveTypes
        },
      },
      abmCodes,
      wseBands,
      groups,
      postcodes,
      subZones,
      zones,
    } = this.props;
    const brands = uniqBy((savedProducts || []).map(savedProduct => savedProduct.brand), 'id');

    return (
      <div className='container-fluid postcode-plan-form'>
        <Row>
          <Col md={12}>
            <BackLink href='/admin/objectives/postcode-plans'/>
            <PageTitle>{`${this.pageTitle()} POSTCODE PLAN ${(!Number.isNaN(this.id) ? `ID: ${this.id}` : '')}`}</PageTitle>
          </Col>
        </Row>
        {!fetched && 'Loading...' }
        {fetched && (
          <Col md={12}>
            <Row>
              <Form model='deep.postcode_plan' onSubmit={this.onSubmit}>
                <Errors className='errors' model='deep.postcode_plan'/>
                <Row>
                  <Col md={12}>
                    <RequiredInput
                      label='Name'
                      tooltip='This name will display to the user in their store performance and points statement pages'
                      model='.name'
                      placeholder='Name'
                      controlId='postcodePlanName'
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="form-group">
                      <FormLabel>Description</FormLabel>
                      <Control.textarea
                        className="form-control"
                        model=".description"
                        rows="5"
                        placeholder="Description"
                        value={description || ''}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <RequiredSelect
                      label='Objective type'
                      model='deep.postcode_plan.objective_type'
                      controlId="objective_type"
                      values={objectiveTypes}
                      valueAttr={objectiveType}
                    />
                  </Col>
                </Row>
                <EligibilityDropdowns
                  mc_outlets={mcOutlets}
                  abm_codes={abmCodes}
                  wse_bands={wseBands}
                  groups={groups}
                  postcodes={postcodes}
                  sub_zones={subZones}
                  zones={zones}
                  model='postcode_plan'
                />
                {(savedAbmCodes || []).map((abmCode) => {
                  const model = `.thresholds.abm-code-${abmCode.value.split('_').join('-')}.threshold`;
                  const label = `${abmCode.value} threshold`;

                  return (
                    <Row key={`abm-code-${abmCode.value.split('_').join('-')}`}>
                      <Col md={12}>
                        {!this.isEdit ? (
                          <div className="form-group">
                            <FormLabel>{label}</FormLabel>
                            <Control.text
                              model={model}
                              placeholder='Threshold'
                              type="number"
                              className="form-control"
                            />
                          </div>
                        ) : (
                          <RequiredInput
                            label={label}
                            model={model}
                            placeholder='Threshold'
                            controlId={'threshold'}
                            inputType='number'
                            positive
                          />
                        )}
                      </Col>
                    </Row>
                  );
                })}
                <Row>
                  <Col md={12}>
                    <RequiredDatePicker
                      label="Start Date"
                      controlId="start_date"
                      model="deep.postcode_plan.start_date"
                      value={startDate}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <RequiredDatePicker
                      label="End Date"
                      controlId="end_date"
                      model="deep.postcode_plan.end_date"
                      value={endDate}
                      required={objectiveType === 'Auto-EPOS'}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <RequiredMultiSelect
                      model='deep.postcode_plan.products'
                      data={products || []}
                      label="Products"
                      value={savedProducts}
                      controlId="products"
                      placeholder='Select...'
                    />
                  </Col>
                </Row>
                {(savedProducts || []).length > 0 && (
                  <Row>
                    {brands.map(brand => (
                      <Col className="objective-row" md={12} key={`brand-${brand.id}`}>
                        <Col md={6}>{brand.name}</Col>
                        <Col md={6}>
                          <RequiredInput
                            label='Points'
                            model={`.brand_points.brand-${brand.id}.points`}
                            placeholder='Points'
                            controlId='points'
                            inputType='number'
                            positive
                          />
                        </Col>
                      </Col>
                    ))}
                  </Row>
                )}
                <Row>
                  <Col md={12}>
                    <div className="form-group">
                      <FormLabel>Opt in Bonus (points)</FormLabel>
                      <Control.text
                        className="form-control"
                        model=".opt_in_bonus_points"
                        placeholder="Opt in Bonus (points)"
                        type='number'
                      />
                    </div>
                  </Col>
                </Row>
                {!this.edit && (
                  <Row>
                    <Col md={12}>
                      <FileUpload
                        label="Opt in Bonus outlets"
                        model='.opt_in_bonus_outlets'
                        type={['text/csv', 'application/vnd.ms-excel']}
                      />
                    </Col>
                  </Row>
                )}
                <Row>
                  <Col md={12}>
                    <RequiredInput
                      label='Administration validation threshold (points)'
                      model='.administration_validation_threshold'
                      placeholder='Administration validation threshold (points)'
                      controlId='administrationValidationThreshold'
                      inputType='number'
                      positive
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <RequiredDatePicker
                      label="Display From Date"
                      controlId="display_from_date"
                      model="deep.postcode_plan.display_from_date"
                      value={displayFromDate}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <RequiredDatePicker
                      label="Display To Date"
                      controlId="display_to_date"
                      model="deep.postcode_plan.display_to_date"
                      value={displayToDate}
                      required={false}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <ArrowButton className='float-right' color='red' disabled={!formValid}>
                      save
                    </ArrowButton>
                  </Col>
                </Row>
              </Form>
            </Row>
          </Col>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  formValid: state.deep.forms.postcode_plan.$form.valid,
  formData: state.deep.postcode_plan,
  postcodePlans: state.postcode_plans,
  groups: state.deep.postcode_plan.groups || [],
  abmCodes: state.deep.postcode_plan.abm_codes || [],
  wseBands: state.deep.postcode_plan.wse_bands || [],
  postcodes: state.deep.postcode_plan.postcodes || [],
  subZones: state.deep.postcode_plan.sub_zones || [],
  zones: state.deep.postcode_plan.zones || [],
  thresholds: state.deep.postcode_plan.thresholds || []
});

export default connect(mapStateToProps)(AddPostcodePlans);
